import { PesticideIndicationsState } from './types';

export default function initialState(): PesticideIndicationsState {
  return {
    data: {},
    fetching: false,
  };
}
